
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SolicitudViatico.css";
import API from "../api";

export default function SolicitudViatico() {
  const navigate = useNavigate();

  const [vehiculoAsignado, setVehiculoAsignado] = useState(null);
  const [rutas, setRutas] = useState([]);

const [rutaSeleccionada, setRutaSeleccionada] = useState("");
const [precioGalon, setPrecioGalon] = useState("");

const [fechaInicio, setFechaInicio] = useState("");
const [fechaFin, setFechaFin] = useState("");

  const [enviando, setEnviando] = useState(false);
  const [mensajeSolicitud, setMensajeSolicitud] = useState("");
  const [errorSolicitud, setErrorSolicitud] = useState("");

  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(true);

  // Obtener el camión asignado y las rutas
  useEffect(() => {
    const cargarDatos = async () => {
      setCargando(true);
      setError("");

      try {
        const token = sessionStorage.getItem("token");

        if (!token) {
          throw new Error("Debes iniciar sesión nuevamente.");
        }

        const [respuestaVehiculo, respuestaRutas] =
          await Promise.all([
            fetch(`${API}/mi-vehiculo`, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }),
            fetch(`${API}/rutas`)
          ]);

        const datosVehiculo = await respuestaVehiculo.json();
        const datosRutas = await respuestaRutas.json();

        if (!respuestaVehiculo.ok) {
          throw new Error(
            datosVehiculo.error ||
            "No se pudo obtener tu camión asignado."
          );
        }

        if (!respuestaRutas.ok) {
          throw new Error(
            datosRutas.error ||
            "No se pudieron obtener las rutas."
          );
        }

        if (datosVehiculo.estado !== "Disponible") {
          throw new Error(
            "Tu camión asignado no está disponible. " +
            "Comunícate con el administrador."
          );
        }

        setVehiculoAsignado(datosVehiculo);
        setRutas(datosRutas);
      } catch (err) {
        setError(err.message);
        setVehiculoAsignado(null);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  // Identificar ruta seleccionada
  const rutaActual = rutas.find(
    (ruta) => String(ruta.id_ruta) === rutaSeleccionada
  );

  // Cálculo de combustible
  const distancia = Number(rutaActual?.distancia_km);

  const rendimiento = Number(
    vehiculoAsignado?.rendimiento_km_galon
  );

  const precio = Number(precioGalon);

  const calculoValido =
    Boolean(vehiculoAsignado) &&
    Boolean(rutaActual) &&
    precioGalon.trim() !== "" &&
    Number.isFinite(distancia) &&
    Number.isFinite(rendimiento) &&
    Number.isFinite(precio) &&
    distancia > 0 &&
    rendimiento > 0 &&
    precio > 0;

  const galones = calculoValido
    ? distancia / rendimiento
    : 0;

  const costoCombustible = calculoValido
    ? galones * precio
    : 0;

  // Cálculo de alimentación
  const TARIFA_ALIMENTACION = 75;

const fechasValidas =
  fechaInicio !== "" &&
  fechaFin !== "" &&
  fechaFin >= fechaInicio;

const dias = fechasValidas
  ? Math.round(
      (
        Date.parse(`${fechaFin}T00:00:00Z`) -
        Date.parse(`${fechaInicio}T00:00:00Z`)
      ) / 86400000
    ) + 1
  : 0;

const diasValidos =
  fechasValidas &&
  Number.isInteger(dias) &&
  dias > 0;

  const costoAlimentacion = diasValidos
    ? dias * TARIFA_ALIMENTACION
    : 0;

  const totalViaticos =
    costoCombustible + costoAlimentacion;

  // Formato de moneda
  const formatoMoneda = (valor) => {
    return `Q${Number(valor).toFixed(2)}`;
  };

  // Registrar solicitud
  const enviarSolicitud = async (e) => {
    e.preventDefault();

    if (
      !calculoValido ||
      !diasValidos ||
      !vehiculoAsignado ||
      enviando ||
      Boolean(error)
    ) {
      return;
    }

    setEnviando(true);
    setMensajeSolicitud("");
    setErrorSolicitud("");

    try {
      const usuarioGuardado =
        sessionStorage.getItem("usuario");

      const token = sessionStorage.getItem("token");

      if (!usuarioGuardado || !token) {
        throw new Error(
          "Debes iniciar sesión nuevamente."
        );
      }

      const usuario = JSON.parse(usuarioGuardado);

      if (usuario.rol !== "Conductor") {
      throw new Error(
         "Solo los conductores pueden solicitar viáticos."
             );
              } 

      const respuesta = await fetch(
        `${API}/solicitudes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
        body: JSON.stringify({
        id_vehiculo: vehiculoAsignado.id_vehiculo,
        id_ruta: Number(rutaSeleccionada),
        precio_galon: Number(precioGalon),
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin
          })
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error ||
          "No se pudo registrar la solicitud."
        );
      }

      setMensajeSolicitud(
        `Solicitud #${datos.id_solicitud} registrada correctamente. ` +
        `Total: ${formatoMoneda(datos.total_viaticos)}. ` +
        `Estado: Pendiente.`
      );

    } catch (err) {
      console.error("Error al enviar solicitud:", err);
      setErrorSolicitud(err.message);
    } finally {
      setEnviando(false);
    }
  };


return (
  <div className="solicitud-container">

    <div className="boton-volver-superior">
      <button
        type="button"
        className="boton-volver-dashboard"
        onClick={() => navigate("/panel-conductor")}
      >
        ← Volver al Dashboard
      </button>
    </div>

    <h1 className="solicitud-titulo">
      Solicitud de viáticos
    </h1>


      <p className="solicitud-subtitulo">
        Completa la información del viaje para calcular
        automáticamente el combustible, la alimentación
        y el monto total de viáticos.
      </p>

      {cargando && (
        <p>Cargando tu camión asignado y las rutas...</p>
      )}

      {error && (
        <p
          className="solicitud-mensaje-error"
          role="alert"
        >
          {error}
        </p>
      )}

      <form
        className="solicitud-formulario"
        onSubmit={enviarSolicitud}
      >
        <h2 className="solicitud-seccion">
          Información del viaje
        </h2>

        <div className="solicitud-campos">

          {/* Camión asignado automáticamente */}
          <div className="solicitud-campo">
            <label htmlFor="vehiculo">
              Camión asignado
            </label>

            <input
              id="vehiculo"
              type="text"
              value={
                vehiculoAsignado
                  ? `${vehiculoAsignado.placa} - ${vehiculoAsignado.marca}`
                  : "Sin camión asignado"
              }
              readOnly
              style={{
                backgroundColor: "#f1f5f9",
                cursor: "not-allowed"
              }}
            />

            {vehiculoAsignado && (
              <small>
                Rendimiento:{" "}
                {vehiculoAsignado.rendimiento_km_galon}{" "}
                km/galón
              </small>
            )}
          </div>

          {/* Ruta */}
          <div className="solicitud-campo">
            <label htmlFor="ruta">
              Ruta del viaje
            </label>

            <select
              id="ruta"
              value={rutaSeleccionada}
              onChange={(e) =>
                setRutaSeleccionada(e.target.value)
              }
              disabled={cargando || Boolean(error)}
              required
            >
              <option value="">
                Seleccione una ruta
              </option>

              {rutas.map((ruta) => (
                <option
                  key={ruta.id_ruta}
                  value={ruta.id_ruta}
                >
                  {ruta.origen} → {ruta.destino}
                </option>
              ))}
            </select>
          </div>

          {/* Precio del combustible */}
          <div className="solicitud-campo">
            <label htmlFor="precioGalon">
              Precio del combustible por galón (Q)
            </label>

            <input
              id="precioGalon"
              type="number"
              min="0.01"
              step="0.01"
              placeholder="Ejemplo: 30.00"
              value={precioGalon}
              onChange={(e) =>
                setPrecioGalon(e.target.value)
              }
              required
            />
          </div>

         {/* Fecha de inicio del viaje */}
<div className="solicitud-campo">
  <label htmlFor="fechaInicio">
    Fecha de inicio del viaje
  </label>

  <input
    id="fechaInicio"
    type="date"
    value={fechaInicio}
    onChange={(e) =>
      setFechaInicio(e.target.value)
    }
    required
  />
</div>

{/* Fecha de finalización del viaje */}
<div className="solicitud-campo">
  <label htmlFor="fechaFin">
    Fecha de finalización del viaje
  </label>

  <input
    id="fechaFin"
    type="date"
    min={fechaInicio || undefined}
    value={fechaFin}
    onChange={(e) =>
      setFechaFin(e.target.value)
    }
    required
  />
</div>

{/* Días calculados automáticamente */}
<div className="solicitud-campo">
  <label>
    Días de viaje
  </label>

  <input
    type="text"
    value={
      diasValidos
        ? `${dias} día${dias !== 1 ? "s" : ""}`
        : "Selecciona las fechas"
    }
    readOnly
    style={{
      backgroundColor: "#f1f5f9",
      cursor: "not-allowed"
    }}
  />
</div>
        </div>

        {/* Resumen automático */}
        {calculoValido && (
          <div className="solicitud-calculo">
            <h3>
              Cálculo automático de combustible
            </h3>

            <div className="solicitud-calculo-fila">
              <span>Distancia de la ruta</span>
              <strong>
                {distancia.toFixed(2)} km
              </strong>
            </div>

            <div className="solicitud-calculo-fila">
              <span>Rendimiento del vehículo</span>
              <strong>
                {rendimiento.toFixed(2)} km/galón
              </strong>
            </div>

            <div className="solicitud-calculo-fila">
              <span>Precio por galón</span>
              <strong>
                {formatoMoneda(precio)}
              </strong>
            </div>

            <div className="solicitud-calculo-fila">
              <span>Galones estimados</span>
              <strong>
                {galones.toFixed(2)}
              </strong>
            </div>

            <div className="solicitud-calculo-fila">
              <span>Total de combustible</span>
              <strong>
                {formatoMoneda(costoCombustible)}
              </strong>
            </div>

            {diasValidos && (
              <>
                <h3 style={{ marginTop: "25px" }}>
                  Alimentación
                </h3>

                <div className="solicitud-calculo-fila">
                  <span>Días de viaje</span>
                  <strong>{dias}</strong>
                </div>

                <div className="solicitud-calculo-fila">
                  <span>Tarifa diaria</span>
                  <strong>
                    {formatoMoneda(TARIFA_ALIMENTACION)}
                  </strong>
                </div>

                <div className="solicitud-calculo-fila">
                  <span>Total de alimentación</span>
                  <strong>
                    {formatoMoneda(costoAlimentacion)}
                  </strong>
                </div>

                <div className="solicitud-calculo-total">
                  <span>
                    Total de viáticos
                  </span>
                  <strong>
                    {formatoMoneda(totalViaticos)}
                  </strong>
                </div>
              </>
            )}
          </div>
        )}

        {/* Botones */}
        <div className="solicitud-acciones">
          <button
            type="submit"
            className="solicitud-boton-enviar"
            disabled={
              !calculoValido ||
              !diasValidos ||
              !vehiculoAsignado ||
              cargando ||
              enviando ||
              Boolean(error)
            }
          >
            {enviando
              ? "Enviando solicitud..."
              : "Enviar solicitud"}
          </button>


        </div>

        {/* Mensajes */}
        {mensajeSolicitud && (
          <p
            className="solicitud-mensaje-exito"
            role="status"
          >
            {mensajeSolicitud}
          </p>
        )}

        {errorSolicitud && (
          <p
            className="solicitud-mensaje-error"
            role="alert"
          >
            {errorSolicitud}
          </p>
        )}
      </form>
    </div>
  );
}
